import { ToastContentProps } from 'react-toastify'
import styles from './Notification.module.css'

interface NotificationProps {
	title?: string,
	text: string
}

export default function Notification({ title, text, toastProps }: NotificationProps & Partial<ToastContentProps>) {
	return (
		<div className={`${styles.notification} ${styles[toastProps!.type]}`}>
			<h6 className={`bodyTextLargeBold ${styles.title}`}>{title}</h6>
			<p className={`bodyTextMedium`}>{text}</p>
		</div>
	)
}
